import React, { useRef, useState } from 'react';
import SubPage from '../SubPage';
import { useLang } from '../../LanguageContext';

const CRUMB = { ko: '고객 센터', en: 'Support' };
const T = {
  title:   { ko: '1:1 문의', en: 'Contact Us' },
  lede:    { ko: '도입 상담이나 궁금한 점을 남겨 주시면 확인 후 연락드립니다.',
             en: 'Leave your question or a consultation request and we will get back to you.' },
  h2:      { ko: '문의 남기기', en: 'Send an Inquiry' },
  name:    { ko: '이름 / 기관명', en: 'Name / Organization' },
  email:   { ko: '이메일', en: 'Email' },
  phone:   { ko: '연락처', en: 'Phone' },
  subject: { ko: '문의 유형', en: 'Inquiry type' },
  message: { ko: '문의 내용', en: 'Message' },
  submit:  { ko: '문의 보내기', en: 'Send' },
  sending: { ko: '보내는 중…', en: 'Sending…' },
  ok:      { ko: '문의가 접수되었습니다. 확인 후 연락드리겠습니다.',
             en: 'Your inquiry has been received. We will contact you soon.' },
  err:     { ko: '전송에 실패했습니다. 잠시 후 다시 시도해 주세요.',
             en: 'Sending failed. Please try again in a moment.' },
  need:    { ko: '이름과 문의 내용을 입력해 주세요.', en: 'Please enter your name and message.' },
  hours:   { ko: '평일 09:00 – 18:00 (주말·공휴일 휴무) · 031-8042-7660 · medilogis@medilogis.net',
             en: 'Mon–Fri 09:00–18:00 · +82-31-8042-7660 · medilogis@medilogis.net' },
};

const SUBJECTS = [
  { v: '도입 상담',   ko: '도입 상담',   en: 'Deployment consultation' },
  { v: '제품 문의',   ko: '제품 문의',   en: 'Product question' },
  { v: '기술 지원',   ko: '기술 지원',   en: 'Technical support' },
  { v: '제휴 · 기타', ko: '제휴 · 기타', en: 'Partnership / Other' },
];

function Inquiry() {
  const { lang } = useLang();
  const [f, setF] = useState({ name: '', email: '', phone: '', subject: SUBJECTS[0].v, message: '' });
  // 스팸 방어: 화면에 안 보이는 칸(허니팟) + 폼을 연 시각
  const [trap, setTrap] = useState('');
  const openedAt = useRef(Date.now());
  const [state, setState] = useState(null);   // null | 'sending' | 'ok' | 'err' | 'need'

  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = (e) => {
    e.preventDefault();
    if (!f.name.trim() || !f.message.trim()) { setState('need'); return; }
    setState('sending');
    fetch('/api/inquiry', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...f, company: trap, elapsed: Date.now() - openedAt.current }),
    })
      .then((r) => r.json())
      .then((d) => {
        if (d && d.success) {
          setState('ok');
          setF({ name: '', email: '', phone: '', subject: SUBJECTS[0].v, message: '' });
        } else setState('err');
      })
      .catch(() => setState('err'));
  };

  return (
    <SubPage crumb={CRUMB[lang]} title={T.title[lang]} lede={T.lede[lang]}>
      <div className="sp-two">
        <div>
          <div className="sp-label">CONTACT</div>
          <h2>{T.h2[lang]}</h2>
          <p className="sp-prose">{T.hours[lang]}</p>
        </div>
        <form className="sp-form" onSubmit={submit}>
          {/* 허니팟 — 사람에게는 보이지 않는다. 봇이 채우면 저장하지 않는다 */}
          <div className="sp-trap" aria-hidden="true">
            <label htmlFor="iq-company">Company</label>
            <input id="iq-company" name="company" type="text" tabIndex="-1"
                   autoComplete="off" value={trap} onChange={(e) => setTrap(e.target.value)} />
          </div>
          <div className="sp-field">
            <label htmlFor="iq-name">{T.name[lang]} *</label>
            <input id="iq-name" value={f.name} onChange={set('name')} required />
          </div>
          <div className="sp-form-2">
            <div className="sp-field">
              <label htmlFor="iq-email">{T.email[lang]}</label>
              <input id="iq-email" type="email" value={f.email} onChange={set('email')} />
            </div>
            <div className="sp-field">
              <label htmlFor="iq-phone">{T.phone[lang]}</label>
              <input id="iq-phone" value={f.phone} onChange={set('phone')} />
            </div>
          </div>
          <div className="sp-field">
            <label htmlFor="iq-subject">{T.subject[lang]}</label>
            <select id="iq-subject" value={f.subject} onChange={set('subject')}>
              {SUBJECTS.map((s) => <option key={s.v} value={s.v}>{s[lang]}</option>)}
            </select>
          </div>
          <div className="sp-field">
            <label htmlFor="iq-message">{T.message[lang]} *</label>
            <textarea id="iq-message" value={f.message} onChange={set('message')} required />
          </div>
          <button type="submit" className="sp-submit" disabled={state === 'sending'}>
            {state === 'sending' ? T.sending[lang] : T.submit[lang]}
          </button>
          {state === 'ok'   && <div className="sp-msg ok">{T.ok[lang]}</div>}
          {state === 'err'  && <div className="sp-msg err">{T.err[lang]}</div>}
          {state === 'need' && <div className="sp-msg err">{T.need[lang]}</div>}
        </form>
      </div>
    </SubPage>
  );
}

export default Inquiry;
